import { BrandListItem } from '../../../integrated-client/models/';

export type BrandsList = Array<BrandListItem>;

export class ResultsData {

  items: BrandsList
  showMore: boolean
  total?: number

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}